import { t } from 'i18next'

const MarketplaceSection = () => (
  <>
    <ul>
      <li>{t('rm:marketplace.payment.description1')}</li>
      <li>{t('rm:marketplace.payment.description2')}</li>
      <li>{t('rm:marketplace.payment.description3')}</li>
    </ul>
  </>
)

export default MarketplaceSection
